import React, { useContext } from "react";
import _ from "lodash";
import { Form, Col } from "react-bootstrap";
import { Select, MenuItem } from "@material-ui/core";
import { ID_TYPES, MEDIA_SEARCH } from "../../constants/MediaSearch";
import { MediaRequestContext } from "../../context/MediaRequestContext";
import "../../styles/media-search.scss";

const MediaRequestIdType = () => {
    const {
        idType,
        _setIdType,
        _setIdQueryType,
        _setIdTypeValues,
        _setSelectedOption,
        _setValidAssets,
        _setOdsEditsData,
        _setOdsSearchIdsData,
        _setIsPromoLoading,
        _setIsCantemoLoading = () => {},
        _setPromoError,
    } = useContext(MediaRequestContext);

    return (
        <Form.Group className="m-0 p-0" as={Col} controlId="idType">
            <Form.Label className="media-request-formLabel">{MEDIA_SEARCH.idTypeFormLabel}</Form.Label>
            <Form.Control
                as={Select}
                disableUnderline={true}
                displayEmpty
                classes={{
                    disabled: "formSelectDisabled"
                }}
                MenuProps={{
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    },
                    transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                    },
                    getContentAnchorEl: null,
                }}
                value={idType}
                onChange={(e) => {
                    const selectedValue = e.target.value;
                    const selectedQueryType = _.get(ID_TYPES.find(type => _.get(type, "value.namespace") === selectedValue), "value.queryType");
                    _setIdType(selectedValue);
                    _setIdQueryType(selectedQueryType);
                    _setIdTypeValues("");
                    _setSelectedOption("");
                    _setOdsEditsData({});
                    _setOdsSearchIdsData({});
                    _setValidAssets({});
                    _setIsPromoLoading(false);
                    _setIsCantemoLoading(false);
                    _setPromoError({});
                }}
                className={"formInputSelect"}
            >
                <MenuItem className="dropdownSelect" value="">
                    -----
                </MenuItem>
                {_.map(ID_TYPES, (idType, index) => {
                    return (
                        <MenuItem
                            className="dropdownSelect"
                            key={index}
                            value={_.get(idType, "value.namespace")}
                        >
                            {_.get(idType, "label")}
                        </MenuItem>
                    );
                })}
            </Form.Control>
        </Form.Group>
    )
}

export default MediaRequestIdType;